// extracted by mini-css-extract-plugin
export default {"PageInscription":"PageInscription_PageInscription__2f8vX","Content":"PageInscription_Content__qKPqF"};